import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7991e71a")

_pushScopeId("data-v-7991e71a")
const _hoisted_1 = {
  "data-testid": "pickup-schedule-config-section-shipment",
  class: "w-full flex flex-col py-3 px-4 bg-white rounded-xl card-border"
}
const _hoisted_2 = { class: "text-base font-bold mb-4" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MultipleSelectProduct = _resolveComponent("MultipleSelectProduct")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("pickup.scheduleConfig.shipment.sectionTitle")), 1),
    _createVNode("div", _hoisted_3, [
      (_ctx.clientName)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 0,
            class: "lg:col-span-2",
            label: _ctx.$t('pickup.scheduleConfig.shipment.clientLabel')
          }, {
            default: _withId(() => [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_Skeleton, {
                    key: 0,
                    class: "mt-1.5",
                    height: "36px",
                    width: "100%"
                  }))
                : (_openBlock(), _createBlock(_component_lp_input, {
                    key: 1,
                    "data-testid": "pickup-schedule-config-input-client-name",
                    class: "mt-1.5",
                    modelValue: _ctx.clientName,
                    disabled: "",
                    disableBackground: ""
                  }, null, 8, ["modelValue"]))
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('pickup.scheduleConfig.shipment.estimateAdditionalKoli'),
        required: ""
      }, {
        default: _withId(() => [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                class: "mt-1.5",
                height: "36px",
                width: "100%"
              }))
            : (_openBlock(), _createBlock(_component_lp_input, {
                key: 1,
                modelValue: _ctx.additionalKoliValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.additionalKoliValue = $event)),
                "data-testid": "pickup-schedule-config-input-estimate-koli",
                class: "mt-1.5",
                placeholder: _ctx.$t('pickup.scheduleConfig.shipment.placeholderKoli'),
                error: Boolean(_ctx.additionalKoliError),
                errorCaption: _ctx.additionalKoliError,
                type: "number"
              }, null, 8, ["modelValue", "placeholder", "error", "errorCaption"]))
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('pickup.scheduleConfig.shipment.estimateWeight'),
        required: ""
      }, {
        default: _withId(() => [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                class: "mt-1.5",
                height: "36px",
                width: "100%"
              }))
            : (_openBlock(), _createBlock(_component_lp_input, {
                key: 1,
                modelValue: _ctx.weightValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.weightValue = $event)),
                "data-testid": "pickup-schedule-config-input-estimate-weight",
                class: "mt-1.5",
                placeholder: _ctx.$t('pickup.scheduleConfig.shipment.placeholderWeight'),
                error: Boolean(_ctx.weightError),
                errorCaption: _ctx.weightError,
                suffix: "kg",
                type: "number"
              }, null, 8, ["modelValue", "placeholder", "error", "errorCaption"]))
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        class: "lg:col-span-2",
        label: _ctx.$t('pickup.scheduleConfig.shipment.serviceType'),
        optional: ""
      }, {
        default: _withId(() => [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                class: "mt-1.5",
                height: "36px",
                width: "100%"
              }))
            : (_openBlock(), _createBlock(_component_MultipleSelectProduct, {
                key: 1,
                modelValue: _ctx.serviceCodeValues,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.serviceCodeValues = $event)),
                "data-testid": "pickup-schedule-config-select-service",
                class: "pickup-schedule-config-service-select mt-1.5",
                status: "active",
                disabledJumboPackH2h: "true",
                placeholder: _ctx.$t('pickup.scheduleConfig.shipment.placeholderService')
              }, null, 8, ["modelValue", "placeholder"]))
        ]),
        _: 1
      }, 8, ["label"])
    ])
  ]))
})